import { injectPostgresEndpoints } from "./postgresApi";
import { userData, Suggestion, EntitlementsData } from "../../types/newtypes";

export const postgresUserApi = injectPostgresEndpoints({
  endpoints: (builder) => ({
    // Get current user data from token
    getCurrentUser: builder.query<userData | null, void>({
      query: () => "/users/me",
      providesTags: [{ type: "Users", id: "ME" }],
      keepUnusedDataFor: 120,
    }),

    // Get user suggestions
    getUserSuggestions: builder.query<Suggestion[], void>({
      query: () => "/users/me/suggestions",
      providesTags: [{ type: "UserSuggestions", id: "LIST" }],
    }),

    // Get user certificates
    getUserCertificates: builder.query<any[], void>({
      query: () => "/certificates",
      providesTags: [{ type: "Certificates", id: "LIST" }],
    }),

    // Update a user tag (e.g., from Poll card)
    updateUserTag: builder.mutation<
      { success: boolean },
      { tag_key: string; tag_value: string | number }
    >({
      query: (body) => ({
        url: "/users/me/tags",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Users", id: "ME" }],
    }),

    // Update job title (for legacy users)
    updateJobTitle: builder.mutation<{ success: boolean; job_title: string }, { job_title: string }>(
      {
        query: (body) => ({
          url: "/users/me/job-title",
          method: "PATCH",
          body,
        }),
        invalidatesTags: [{ type: "Users", id: "ME" }],
      }
    ),

    // Get user entitlements
    getEntitlements: builder.query<EntitlementsData, void>({
      query: () => "/users/me/entitlements",
      providesTags: [{ type: "Users", id: "ENTITLEMENTS" }],
      keepUnusedDataFor: 300, // Cache for 5 minutes
    }),
  }),
});

export const {
  useGetCurrentUserQuery,
  useGetUserSuggestionsQuery,
  useGetUserCertificatesQuery,
  useUpdateUserTagMutation,
  useUpdateJobTitleMutation,
  useGetEntitlementsQuery,
} = postgresUserApi;
